export default __webpack_public_path__ + "static/media/dashed line.67456727.svg";